import React, { useMemo } from 'react';
import LclKanbanColumn from './LclKanbanColumn';
import LclOperationCard from '../LclOperationCard';

/**
 * Columna "Finalizadas" — agrupa solicitudes LCL en estado `Aprobada`.
 *
 * Archivo independiente para poder ajustar esta columna sin tocar
 * las otras tres ni nada del módulo aéreo.
 */
const LclFinalizadasColumn = ({
  items = [],
  onAction,
  loading = false,
  headerExtra,
  actionsMode = 'full',
}) => {
  // `renderItem` se memoriza para no recrearlo en cada render del padre
  const renderItem = useMemo(
    () => (r) => (
      <LclOperationCard
        r={r}
        variant="finalizadas"
        onAction={onAction}
        actionsMode={actionsMode}
      />
    ),
    [onAction, actionsMode],
  );

  return (
    <LclKanbanColumn
      id="finalizadas"
      title="Finalizadas"
      accent="border-t-emerald-500"
      badge="bg-emerald-100 text-emerald-800 border-emerald-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin solicitudes finalizadas"
      headerExtra={headerExtra}
    />
  );
};

export default LclFinalizadasColumn;
